import AppChannel from "../AppChannel";
import RunnedAppModel from "./model/RunnedAppModel";


export default class RunnedAppsChannel extends AppChannel {
    add(item) {
        let runnedAppModel = new RunnedAppModel(item);
        this.trigger("add", runnedAppModel);

        runnedAppModel.on("remove", function() {
            this.trigger("remove", runnedAppModel);
        }.bind(this));

        return runnedAppModel;
    }
}